import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConsumidorFormatter, ConsumidorModel } from '../shared/consumidor.model';
import { InstituicaoModel } from '../../instituicao/shared/index';
import { NbpInfoComponent, GenericHttpService, ParametrosService, ConfiguracoesProjeto } from '../../../shared/index';
import { LoadingService } from '../../../shared-layout/loading/loading.service';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { StatusCpfCidadao } from '../../../shared/model/status-cpf-cidadao.model';

@Injectable()
export class ConsumidorService {

    public _urlBase: string;

    public _urlBaseGeral: string;

    public consumidorModel: ConsumidorModel = new ConsumidorModel();

    public editMode = false;
    public consumidorChange = new Subject<ConsumidorModel>();
    public consumidoresChange = new Subject<ConsumidorModel[]>();
    public editModeChange = new Subject<boolean>();
    public consumidorError = new Subject<string>();
    public editSenhaMode = false;
    public configuracao: ConfiguracoesProjeto;
    public mn0030: string;

    public isSenhaAlterada = false;
    public instituicaoDesativada: string;

    public mensagemErro: string;

    constructor(private readonly genericHttpService: GenericHttpService<ConsumidorModel>,
                private readonly genericHttp: GenericHttpService<StatusCpfCidadao>,
                private readonly router: Router,
                private readonly ngbModalService: NgbModal,
                private readonly loadingService: LoadingService,
                private readonly parametrosService: ParametrosService) {

        this.instituicaoDesativada = '';
    }

    get urlBase() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBase = this.configuracao.uri + 'consumidor/';
        return this._urlBase;
    }

    get urlBaseGeral() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBaseGeral = this.configuracao.uri + 'consumidor-geral/';
        return this._urlBaseGeral;
    }

    get urlBaseCadastramento() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBaseGeral = this.configuracao.uri + 'cadastramento-cidadao/';
        return this._urlBaseGeral;
    }

    get urlBaseConsumidorInstituicao() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBaseGeral = this.configuracao.uri + 'instituicao-cidadao/';
        return this._urlBaseGeral;
    }

    get urlBaseConsumidorDescadastramento() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBaseGeral = this.configuracao.uri + 'descadastramento-cidadao/';
        return this._urlBaseGeral;
    }

    setConsumidorModel(consumidorModel: ConsumidorModel) {
        consumidorModel.stsParticipaSorteio = consumidorModel.statusParticipanteSorteio;
        this.consumidorModel = consumidorModel as ConsumidorModel;
        localStorage.setItem('consumidor', JSON.stringify(consumidorModel));
        this.consumidorChange.next(this.consumidorModel);
    }

    setConsumidorModelNovo(consumidorModel: ConsumidorModel) {
        this.consumidorModel = consumidorModel as ConsumidorModel;
        localStorage.removeItem('consumidor');
        this.setEditMode(false);
    }

    getConsumidorModel(): ConsumidorModel {
        
        // Caso esteja em modo de edição capturo o valor do consumidor setado no localstorage
        if (this.editMode) {
            // CAPTURO VALOR ARMAZENADO NO LOCALSTORAGE
            const consumidorSession: ConsumidorModel = (<ConsumidorModel> JSON.parse(localStorage.getItem('consumidor')));
            this.consumidorModel = (<ConsumidorModel>consumidorSession);
            this.consumidorChange.next(this.consumidorModel);
        }
        return this.consumidorModel;
    }

    getConsumidorPeloCPF(cpf: number): Observable<ConsumidorModel> {
        return this.genericHttpService.getById(this.urlBase + `consultar/${cpf}`);
    }

    getConsumidorPeloCPFParaRecuperacaoAcesso(cpf: number): Observable<ConsumidorModel> {
        return this.genericHttpService.getById(this.urlBaseGeral + `status-recuperacao-senha/${cpf}`);
    }

    getConsumidorPeloCPFString(cpf: string): Observable<ConsumidorModel> {
        return this.genericHttpService.getById(this.urlBase + `consultar/${cpf}`);
    }

    getConsumidorComImpedimentoPeloCPF(cpf: number): Observable<ConsumidorModel> {
        return this.genericHttpService.getById(this.urlBase + `consultarComImpedimento/${cpf}`);
    }

    getStatusCPF(cpf: number) : Observable<StatusCpfCidadao> {
        return this.genericHttp.getById(this.urlBaseGeral + `status-cpf/${cpf}`);
    }

     getSituacaoCadastroCPF(cpf: number): Observable<ConsumidorModel> {
        return this.genericHttpService.getById(this.urlBaseGeral + `situacao-cadastro/${cpf}`);
    }

    getConsumidorPeloCPFSubjec(cpf) {
      this.loadingService.exibirLoading('Aguarde enquanto está sendo consultado o CPF.');
        this.genericHttpService.getById(this.urlBase + `consultar/${cpf}`)
            .subscribe(
                (data) => {
                    this.setEditMode(true);
                    this.consumidorModel = (<ConsumidorModel>data);
                    this.consumidorChange.next(this.consumidorModel);
                    this.loadingService.esconderLoading();
                },
                (error) => {
                    this.loadingService.esconderLoading();
                    this.consumidorError.next(error);
                }
                ,
                () => {
                  this.loadingService.esconderLoading();
                }
            );
    }

    atualizarConsumidor(consumidor: ConsumidorModel) {
        return this.genericHttpService.put(this.urlBase + `atualizacao`, consumidor);       
    }


    putInstituicoes(consumidor: ConsumidorModel, mensagem: String = '') {
        return this.genericHttpService.put(this.urlBase + `atualizacao-instituicoes`, consumidor);
    }

    deleteInstituicoes(consumidor: ConsumidorModel, mensagem: String = '') {
        return this.genericHttpService.put(this.urlBase + `exclusao-instituicoes`, consumidor);
    }

    postConsumidorDadosAdicionais(consumidor: ConsumidorModel): Observable<any> {
        return this.genericHttpService.post(this.urlBaseCadastramento + `novo`, consumidor);
    }

    putConsumidorDescadastrar(consumidor: ConsumidorModel) {
        // FORMATO O CPF POIS A API ESPERA O RETORNO DESSE CAMPO
        consumidor.cpf = ConsumidorFormatter.pad(consumidor.cpfBase, 9) + '' + ConsumidorFormatter.pad(consumidor.cpfDigito, 2);
        this.loadingService.exibirLoading('Aguarde');
        this.genericHttpService.putAny(this.urlBaseConsumidorDescadastramento + `descadastramento`, consumidor.consumidorId)
            .subscribe(
                (data) => {
                    const confirmModal = this.ngbModalService.open(NbpInfoComponent);

                    confirmModal.componentInstance.info = 'Cidadão continua participando dos sorteios com os  ' +
                    'bilhetes gerados até o momento.' +
                    'A partir de agora as notas fiscais emitidas com seu CPF não participarão dos sorteios do NPB.';
                    this.setConsumidorModel(consumidor);
                    this.router.navigate(['consumidor/descadastrado']);
                },
                (error: any) => {

                    this.loadingService.esconderLoading();

                    const confirmModal = this.ngbModalService.open(NbpInfoComponent);

                    let err = error as StatusRequisicao;

                    confirmModal.componentInstance.info = err.motivo;
                    this.setConsumidorModel(consumidor);
                },
                () => {
                  this.loadingService.esconderLoading();
                }
        );
    }

    getInstituicoesPeloCPF(cpf: string)  {
        this.loadingService.exibirLoading('Aguarde');
        this.genericHttpService.getAny(this.urlBaseConsumidorInstituicao + `listagem/instituicoes/${cpf}`)
        .subscribe(
            (data) => {
                this.consumidorModel.instituicoes = <InstituicaoModel[]> data;
                this.consumidorChange.next(this.consumidorModel);
            },
            (error) => {
               this.loadingService.esconderLoading();
            },
            () => {
               this.loadingService.esconderLoading();
            }
        );
    }

    public setEditMode(_editMode: boolean) {
        this.editMode = _editMode;
        sessionStorage.setItem('editMode', (_editMode) ? '1' : '0');
        this.editModeChange.next(_editMode);
    }

    public getEditMode(): boolean {
        const sessionEdit = sessionStorage.getItem('editMode');
        const dadosAutorizacaoStr = localStorage.getItem('authorizationData');

        this.editMode = false;

        if (sessionEdit != null && +sessionEdit && dadosAutorizacaoStr) {
            this.editMode = true;
        }

        return this.editMode;
    }
}




// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor.service.ts